import type { I18nDictionaryShape } from '../../types';
import type { commonEnGb } from '../en-GB/common';

export const commonSrRs = {
  brand: {
    logoAlt: 'Safi logotip',
    name: 'Safi',
    vatLabel: 'PIB kompanije Safi',
  },
  currencySelectField: {
    groups: {
      other: 'Ostalo',
      suggested: 'Predloženo',
    },
  },
  domains: {
    evidence: 'Dokazi',
    evidenceLower: 'dokazi',
    qualityControl: 'Kontrola kvaliteta',
    qualityControlLower: 'kontrola kvaliteta',
  },
  values: {
    emptyValue: '-',
  },
} satisfies I18nDictionaryShape<typeof commonEnGb>;
